import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import workOrderApi, { WorkOrderData } from '../apis/workOrder.api'
import itemApi from '../apis/item.api'
import { PalletData } from '../apis/pallet.api'
import ContentAside from '../components/ContentAside'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import ItemCard, { ItemCardData } from '../components/ItemCard'
import InventoryCreateForm from '../partials/InventoryCreateForm'

interface InventoryCreateProps extends RouteComponentProps {}

interface InventoryCreateState {
  item: ItemCardData | null
  lastPallet: PalletData | null
  workOrder: WorkOrderData | null
}

class InventoryCreate
  extends Component<InventoryCreateProps, InventoryCreateState> {
  constructor (props: InventoryCreateProps) {
    super(props)
    this.state = {
      item: null,
      lastPallet: null,
      workOrder: null
    }
    this.handleWorkOrderSelect = this.handleWorkOrderSelect.bind(this)
  }

  get itemCard () {
    const { item, lastPallet, workOrder } = this.state
    const lastPalletCode = lastPallet ? lastPallet.code : null
    const lastPalletNumber = lastPallet && lastPallet.number
      ? lastPallet.number
      : null
    return item && workOrder && workOrder.quantity &&
      <ItemCard
        code={item.code}
        description={item.description}
        cpp={item.cpp}
        qpc={item.qpc}
        remainingQuantity={workOrder.quantity.remaining}
        lastPallet={lastPalletCode}
        lastPalletNumber={lastPalletNumber} />
  }

  readItem (id: number) {
    itemApi.read(id, item => {
      if (!item) return
      this.setState({ item })
    })
  }

  readWorkOrderLastPallet (workOrderId: number) {
    workOrderApi.readLastPallet(workOrderId, pallet => {
      if (!pallet) return
      this.setState({ lastPallet: pallet })
    })
  }

  handleWorkOrderSelect (workOrder: WorkOrderData | null) {
    if (!workOrder) {
      this.setState({
        item: null,
        lastPallet: null,
        workOrder: null
      })
      return
    }
    this.setState({ workOrder }, () => {
      if (workOrder.item) this.readItem(workOrder.item.id)
      this.readWorkOrderLastPallet(workOrder.id)
    })
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="twoThird">
          <InventoryCreateForm onWorkOrderSelect={this.handleWorkOrderSelect} />
        </ContentMain>
        <ContentAside layout="oneThird">
          {this.itemCard}
        </ContentAside>
      </ContentLayout>
    )
  }
}

export default withRouter(InventoryCreate)
